<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <UploadImage @snack="snackmain" @reloadImages="reloadImages" :title="uploaderTitle"
                    v-bind:isProfilePicture=true></UploadImage>
            </v-col>
            <v-col>
                <S3Gallery @snack="snackmain" :refreshTrigger="trigger" v-bind:isProfilePicture=true></S3Gallery>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
//import RestResource from '../RestResource.js';
import UploadImage from "../components/UploadImage.vue";
import S3Gallery from "../components/S3Gallery.vue";
import accessHelper from "@/mixins/accessHelper";
//const restResourceService = new RestResource();

export default {
    name: "ProfilePictureSelectionPage",
    setup() {

    },
    mixins: [accessHelper],
    props: {

    },
    components: {
        UploadImage,
        S3Gallery
    },
    data: () => ({
        uploaderTitle: "Upload new profile picture",
        trigger: 0
    }),
    watch: {

    },
    methods: {
        snackmain: function (message) {
            this.$emit('snack', message);
        },
        //Used called from uploader, then trigger passed to gallery to refresh
        reloadImages: function () {
            console.log("Reload Images");
            this.trigger = this.trigger + 1;
        },
    },
}
</script>

<style scoped>
</style>